export default __webpack_public_path__ + "fonts/inter-latin-300-normal.e7bf730f225ab458aead.woff";